import CertsControlsMore from './CertsControlsMore';

export default CertsControlsMore;
